import HttpClient from '@/utility/http-client';

export default {
    getList(page: number, rowPerPage: number) {
        const url = `/api/pricing/?page=${page}&rowsPerPage=${rowPerPage}` ;
        return HttpClient.instance().get(url);
    },
    getDetail(id: number = 0) {
        const url = `/api/pricing/${id}`;
        return HttpClient.instance().get(url);
    }
};
